import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';

export interface BatchEditRequest {
    command: string;
    assets: number[];
}

@Component({
  selector: 'app-common-group-header',
  templateUrl: './common-group-header.component.html',
  styleUrls: ['./common-group-header.component.scss']
})
export class CommonGroupHeaderComponent implements OnInit {
    pageSizeLocal = 0;
    @Input('pageSize') set pageSize(newPageSize: number){
        console.log("Group header setter property for page size", newPageSize);
        this.pageSizeLocal = newPageSize;
    }
    @Input('pageSizeOptions') pageSizeOptions = [];
    @Input('mode') mode = 'assets';
    searchTerm = '';
    @Input('itemCount') itemCount = 0;
    @Input('optionalDisplayColumns') optionalDisplayColumns = [];
    @Input('name') name = '';
    
    @Input('selectedIds') selectedIds: number[] = [];

    pageIndex = 0;
    @Input('currentPageIndex') set currentPageIndex(newPageIndex: number){
        console.log("Tab header control is being notified that the loaded page index has changed", newPageIndex);
        this.pageIndex = newPageIndex;
        if(this.paginator){
            this.paginator.pageIndex = newPageIndex;   
        }
    }

    @Input() enableSearch = true;
    @Input() enableSettings = true;
    @Input() enableBatch = true;
    @Input() enableTitle = true;

    @Output('updatePageSize') updatePageSizeEmitter = new EventEmitter<number>();    
    @Output('searchExecute') searchExecuteEmitter = new EventEmitter<string>();
    @Output('searchClear') searchClearEmitter = new EventEmitter<boolean>();
    @Output('updatePage') updatePageEmitter = new EventEmitter<number>();
    @Output('setupDisplayColumns') setupDisplayColumnsEmitter = new EventEmitter<boolean>();
    @Output('batchEditCommand') batchEditCommand = new EventEmitter<string>();
    
    @ViewChild('paginator') paginator : MatPaginator;

    constructor() { }

    ngOnInit(): void {
    }

    searchExecute(){
        this.searchExecuteEmitter.emit(this.searchTerm);
    }

    searchClear(){
        this.searchTerm = ''
        this.searchClearEmitter.emit(true);
    }

    updatePageSize(){
        console.log("Group common header pagesizeupdated notification being generated", this.pageSizeLocal);
        this.updatePageSizeEmitter.emit(this.pageSizeLocal);
    }

    updatePage(){
        this.updatePageEmitter.emit(this.paginator.pageIndex);
    }

    setupDisplayColumns(){
        this.setupDisplayColumnsEmitter.emit(true);
    }

    executeBatchCommand(command: string){
        this.batchEditCommand.emit(command);
    }
}
